import React from 'react';
import { Sparkles, FileText, TrendingUp, Users, Mail, Sliders } from 'lucide-react';

export const AdminQuickActionsCard: React.FC = () => {
  return (
    <div className="bg-linear-to-br from-indigo-600 to-indigo-900 p-5 rounded-2xl shadow-lg border border-indigo-500 text-white space-y-4">
      <div>
        <h3 className="text-sm font-bold text-white flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-amber-300" />
          <span>Pusat Kendali Admin</span>
        </h3>
        <p className="text-[10px] text-indigo-100 mt-0.5">Akses cepat fitur manajemen tingkat tinggi</p>
      </div>

      <div className="grid grid-cols-1 gap-2">
        <button
          onClick={() => {
            const navBtn = document.getElementById('nav-tab-newsletter');
            if (navBtn) navBtn.click();
          }}
          className="w-full py-2.5 px-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/10 text-left transition flex items-center justify-between group cursor-pointer"
        >
          <div className="flex items-center gap-2.5">
            <Mail className="w-4 h-4 text-indigo-200" />
            <span className="text-xs font-bold">Kelola Newsletter</span>
          </div>
          <TrendingUp className="w-3.5 h-3.5 text-white/40 group-hover:translate-x-0.5 transition" />
        </button>

        <button
          onClick={() => {
            const navBtn = document.getElementById('nav-tab-api-docs');
            if (navBtn) navBtn.click();
          }}
          className="w-full py-2.5 px-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/10 text-left transition flex items-center justify-between group cursor-pointer"
        >
          <div className="flex items-center gap-2.5">
            <FileText className="w-4 h-4 text-indigo-200" />
            <span className="text-xs font-bold">Kelola Artikel Blog</span>
          </div>
          <TrendingUp className="w-3.5 h-3.5 text-white/40 group-hover:translate-x-0.5 transition" />
        </button>

        <button
          onClick={() => {
            const navBtn = document.getElementById('nav-tab-api-docs');
            if (navBtn) navBtn.click();
          }}
          className="w-full py-2.5 px-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/10 text-left transition flex items-center justify-between group cursor-pointer"
        >
          <div className="flex items-center gap-2.5">
            <Users className="w-4 h-4 text-indigo-200" />
            <span className="text-xs font-bold">Manajemen Pengguna</span>
          </div>
          <TrendingUp className="w-3.5 h-3.5 text-white/40 group-hover:translate-x-0.5 transition" />
        </button>

        <button
          onClick={() => {
            const navBtn = document.getElementById('nav-tab-api-docs');
            if (navBtn) navBtn.click();
          }}
          className="w-full py-2.5 px-3 rounded-xl bg-white/10 hover:bg-white/20 border border-white/10 text-left transition flex items-center justify-between group group-hover:ring-1 group-hover:ring-white/30 cursor-pointer"
        >
          <div className="flex items-center gap-2.5">
            <Sliders className="w-4 h-4 text-indigo-200" />
            <span className="text-xs font-bold">Konfigurasi R2 & Sistem</span>
          </div>
          <TrendingUp className="w-3.5 h-3.5 text-white/40 group-hover:translate-x-0.5 transition" />
        </button>
      </div>
    </div>
  );
};
